/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';

function Page() {
  const loosGoal = useStore((state) => state.loosGoal);
  const setLoosGoal = useStore((state) => state.setLoosGoal);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.loosGoal.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={loosGoal}
          onChange={(value: string) => {
            setLoosGoal(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'loss-goal',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'Lose 1-10 kg for good'}>{t('onboarding.loosGoal.options.1')}</Option>
          <Option value={'Lose 11-20 kg for good'}>{t('onboarding.loosGoal.options.11')}</Option>
          <Option value={'Lose over 20 kg for good'}>{t('onboarding.loosGoal.options.20')}</Option>
          <Option value={'Maintain weight and get fit'}>
            {t('onboarding.loosGoal.options.maintain')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
